import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { CITY_ALIASES, allCityAliasPaths } from "../data/city-aliases";
import { findCity } from "../data/cities";
import { siteUrl } from "../lib/siteUrl";
import { PHONE_DISPLAY, PHONE_TEL } from "../components/Layout";

/**
 * Static redirect page for short-form city URLs.
 *
 * Redirect mechanism = <meta http-equiv="refresh" content="0; url=…">.
 * Native to browsers and understood by Google as an equivalent of a 301.
 * No JS-based redirect — that would break the react-snap crawler.
 */
export default function CityAliasRedirect() {
    const location = useLocation();
    const shortSlug = location.pathname.replace(/^\/reparateur-electromenager-/, "");
    const canonical = CITY_ALIASES[shortSlug];

    const fullPath = canonical ? `/reparateur-electromenager-${canonical}` : "/zones-intervention";
    const cityName = canonical ? (findCity(canonical)?.name ?? canonical) : "Zones d'intervention";
    const canonicalUrl = siteUrl(fullPath);

    return (
        <>
            <Helmet>
                <title>{`Réparateur Électroménager ${cityName} – Page déplacée | Electrocase`}</title>
                <meta name="description" content={`Page déplacée vers ${canonicalUrl}`} />
                <meta name="robots" content="noindex,follow" />
                <link rel="canonical" href={canonicalUrl} />
                <meta httpEquiv="refresh" content={`1; url=${canonicalUrl}`} />
            </Helmet>
            <main className="min-h-[60vh] flex items-center justify-center bg-[var(--paper)] px-5">
                <div className="text-center max-w-lg">
                    <i className="fa-solid fa-arrow-right-long text-[var(--amber)] text-4xl" />
                    <h1 className="heading text-3xl font-extrabold mt-5 text-[var(--navy)]">
                        Page déplacée
                    </h1>
                    <p className="mt-3 text-[var(--ink-soft)]">
                        Si la redirection ne se fait pas automatiquement :
                    </p>
                    <a href={fullPath} className="btn-amber inline-flex items-center gap-2 px-6 py-3 rounded-full font-bold mt-6">
                        Continuer vers {cityName} <i className="fa-solid fa-arrow-right" />
                    </a>
                    <p className="mt-4 text-sm text-[var(--ink-soft)]">
                        Ou appelez-nous directement au{" "}
                        <a href={PHONE_TEL} className="font-bold text-[var(--navy)] underline decoration-[var(--amber)] decoration-2">
                            {PHONE_DISPLAY}
                        </a>
                    </p>
                </div>
            </main>
        </>
    );
}

export { allCityAliasPaths };
